<div class="row">
    <div class="col-6">
        <h1>Pagos</h1>
    </div>
    <div class="col-6 ">
      <div style="text-align: right">
        <input type="month" id="start" name="start"
       min="2022-08" [(ngModel)]="date" (change)="getInstallmentes()">
      </div>
    </div>
</div>

<!--app-users-->
<div class="row">
    <div class="col-md-12">
        <div class="card">
            <div class="card-body">
                <div class="table-responsive">
                    <table class="table">
                    <thead>
                        <tr>
                        <th scope="col">Contracto</th>
                        <th scope="col"># pago</th>
                        <th scope="col">Client</th>
                        <th scope="col">Cantidad</th>
                        <th scope="col">Fecha de pago</th>
                        <th scope="col">Referencia</th>
                        <th scope="col">Status</th>
                        <th scope="col"></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let installment of installments">
                        <td><a target="_blank" routerLink="/loans/contract-details/{{installment.contractId}}" >{{ installment.contractId }}</a></td>
                        <td>{{ installment.amortization.installmentNo }}</td>
                        <td>{{ installment.solicitante.name }}</td>
                        <td>{{ installment.amortization.thisPaymentAmount | currency }}</td>
                        <td>{{ installment.amortization.thisDate | date:'short'  }}</td>
                        <td>{{ installment.amortization?.reference }}</td>
                        <td *ngIf="installment.amortization?.paid"><span style="color: green;">Pagado</span></td>
                        <td *ngIf="!installment.amortization?.paid"><span style="color: red;">Pendiente</span></td>
                        <td><button type="button" (click)="markPaid(installment)" class="btn btn-secondary" data-toggle="modal" data-target="#editPayModal">Editar</button></td>
                        </tr>
                    </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</div>
<!-- <app-edit-payment [installmentData]="installmentEdit"></app-edit-payment> -->

<div *ngIf="loading" class="d-flex justify-content-center loading-screen">
    <div class="spinner-border" role="status">
      <span class="sr-only"></span>
    </div>
  </div>


  
<!-- Modal -->
<div class="modal fade" id="editPayModal" tabindex="-1" role="dialog" aria-labelledby="editPayModalLabel" aria-hidden="true">
    <div *ngIf="paymentEdit" class="modal-dialog" role="document">
        <div class="modal-content">
        <div class="modal-header">
            <h5 class="modal-title" id="editPayModalLabel">Pago: {{ paymentEdit.amortization.installmentNo | currency }} | Contrato: {{paymentEdit.contractId}}</h5>
            <button type="button" class="close modal-close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
            </button>
        </div>
        <form [formGroup]="editPayForm" (ngSubmit)="editPayment()">
        <div class="modal-body">
            <div class="form-group">
                <label for="reference">Número de refencia</label>
                <input type="text"  class="form-control" id="reference" formControlName="reference">
            </div>
            <div class="form-group mt-2">
                <label for="paid">Pagado</label>
                <select class="form-control" id="paid" formControlName="paid">
                    <option value="true">Pagado</option>
                    <option value="false">Pendiente</option>
                </select>
            </div>    
        </div>
        <div *ngIf="missingFieldMsg" class="alert alert-danger" role="alert">
            Falta algun campo...
        </div>
        <div *ngIf="errorMsg" class="alert alert-danger" role="alert">
            Error intente luego...
        </div>
        <div class="modal-footer">
            
            <button type="button" #closeBtn class="btn btn-secondary" data-dismiss="modal">Close</button>
            <button type="submit" class="btn btn-primary">Guardar</button>
        </div>
        </form>
        </div>
    </div>
</div>